export default __webpack_public_path__ + "04e5abfdb3f7e1c1a960a4d44394df7a.png";